export default __webpack_public_path__ + "static/OggText-Extrabold-fe9446c78f5c7141331065e6aecadcf6.ttf";